import { render, staticRenderFns } from "./videoPage.vue?vue&type=template&id=f962fd98&scoped=true"
import script from "./videoPage.vue?vue&type=script&lang=js"
export * from "./videoPage.vue?vue&type=script&lang=js"
import style0 from "./videoPage.scss?vue&type=style&index=0&id=f962fd98&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f962fd98",
  null
  
)

export default component.exports